export default __webpack_public_path__ + "images/O6.2f0446f.png";